import React from 'react';
import styled from 'styled-components';
import backImage2 from '../../../assets/images/backImage2.png';
import backImage4 from '../../../assets/images/backImage4.png';
import backImage5_mobile from '../../../assets/images/backImage5_mobile.svg';
import backImage6_mobile from '../../../assets/images/backImage6_mobile.svg';
import StepIcon1 from '../../../assets/images/step-icon1.png';
import StepIcon2 from '../../../assets/images/step-icon2.png';
import StepIcon3 from '../../../assets/images/step-icon3.png';
import StepIcon4 from '../../../assets/images/step-icon4.png';

export default function SupportMatchingMobile() {
  return (
    <Wrapper>
      <BackImage
        style={{ width: '110px', height: '180px' }}
        src={backImage2}
        left="0%"
        top="35%"
      />
      <BackImage src={backImage5_mobile} right="0%" top="85%" />
      <BackImage src={backImage4} left="75%" top="50%" />
      <BackImage src={backImage6_mobile} left="7%" top="97%" />
      <TitleWrapper>
        <Title>연수생-구인처 수요 매칭</Title>
      </TitleWrapper>
      <GroupWrapper>
        <Group>
          <StepWrap>
            <StepTitle>01</StepTitle>
            <StepText>STEP</StepText>
          </StepWrap>
          <StepImage src={StepIcon1} alt="Step 1 Icon" />
          <CircleTitle>연수생 역량관리</CircleTitle>
          <Divider />
          <CircleText>
            기업요구 역량 스킬업
            <br />
            연수생 진로 취업상담
            <br />
            기업면담, 구인요구분석
          </CircleText>
        </Group>
        <Group>
          <StepWrap>
            <StepTitle>02</StepTitle>
            <StepText>STEP</StepText>
          </StepWrap>
          <StepImage src={StepIcon2} alt="Step 2 Icon" />
          <CircleTitle>취업매칭 (면접)</CircleTitle>
          <Divider />
          <CircleText>
            회사설명회, 정보안내
            <br />
            수요기업-연수생 매칭
            <br />
            면접진행, 집중 스케줄링
          </CircleText>
        </Group>
        <Group>
          <StepWrap>
            <StepTitle>03</StepTitle>
            <StepText>STEP</StepText>
          </StepWrap>
          <StepImage src={StepIcon3} alt="Step 3 Icon" />
          <CircleTitle>결과관리</CircleTitle>
          <Divider />
          <CircleText>
            취업자/미취업자 관리
            <br />
            취업조건, 입직지원
            <br />
            결과 피드백
          </CircleText>
        </Group>
        <Group>
          <StepWrap>
            <StepTitle>04</StepTitle>
            <StepText>STEP</StepText>
          </StepWrap>
          <StepImage src={StepIcon4} alt="Step 4 Icon" />
          <CircleTitle>성과관리</CircleTitle>
          <Divider />
          <CircleText>
            취업자 업무적응 지원
            <br />
            기업 네트워크 관리
            <br />
            취업자 사후관리
          </CircleText>
        </Group>
      </GroupWrapper>
    </Wrapper>
  );
}

const BackImage = styled.img`
  position: absolute;
  left: ${(props) => props.left};
  top: ${(props) => props.top};
  right: ${(props) => props.right};
`;

const Wrapper = styled.div`
  width: 100%;
  height: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5rem;
  padding-top: 3rem;
  position: relative;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

const GroupWrapper = styled.div`
  width: 240px;
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const Title = styled.span`
  color: rgb(34, 34, 34);
  font-size: 1.25rem;
  font-family: Pretendard, sans-serif;
  font-weight: 600;
  text-align: center;
`;

const Group = styled.div`
  width: 100%;
  height: 280px;
  background-color: #e6f4fa;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  padding: 20px;
  gap: 1rem;
`;

const StepWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  background-color: #2674ff;
  position: absolute;
  top: -30px;
`;

const StepTitle = styled.div`
  color: #ffffff;
  font-size: 20px;
  font-weight: 800;
  text-align: center;
`;

const StepText = styled.div`
  color: #ffffff;
  font-size: 10px;
  font-weight: 800;
  text-align: center;
`;

const CircleTitle = styled.span`
  color: #1a3a5f;
  font-size: 1.25rem;
  font-family: Pretendard, sans-serif;
  font-weight: 700;
  text-align: center;
`;

const StepImage = styled.img`
  width: 60px;
  height: 60px;
`;

const CircleText = styled.span`
  color: #333;
  font-size: 0.88rem;
  font-family: Pretendard, sans-serif;
  font-weight: 400;
  text-align: center;
  white-space: pre-line;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #ffffff66;
`;
